/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{makeUseVisualState as t}from"../../motion/utils/use-visual-state.js";import{scrapeMotionValuesFromProps as e}from"./utils/scrape-motion-values.js";import{createHtmlRenderState as s}from"./utils/create-render-state.js";const o={useVisualState:t({scrapeMotionValuesFromProps:e,createRenderState:s})};export{o as htmlMotionConfig};
//# sourceMappingURL=config-motion.js.map
